import React from 'react';

const PlayIcon = ({ size = 32, ...props }) => {

  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 6.4999V4.27489C1 1.51656 2.95833 0.383229 5.35 1.76656L7.275 2.88323L9.2 3.9999C11.5917 5.38323 11.5917 7.64156 9.2 9.02489L7.275 10.1416L5.35 11.2582C2.95833 12.6166 1 11.4916 1 8.7249V6.4999Z" fill="white" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>


  );
};

export default PlayIcon;
